module.exports = __webpack_public_path__ + "img/immersion-default.3a557529.png";